export type QuoteLogoFiles = {
  logo_dark?: string;
  logo_light?: string;
  mark_composite_dark?: string;
  mark_composite_light?: string;
  mark_dark?: string;
  mark_light?: string;
};

export const logoUrlFromQuote = (logo?: { files?: QuoteLogoFiles } | null): string | null => {
  const files = logo?.files;
  if (!files) {
    return null;
  }
  return (
    files.mark_composite_light ||
    files.mark_light ||
    files.logo_light ||
    files.mark_composite_dark ||
    files.logo_dark ||
    null
  );
};
